import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";

// Obtiene Excel con informe aprobado
export const getReport = createAsyncThunk(
    "attendanceReport/getReport",
    async ({month, year, organization}:{month: string, year: string, organization: string}, { rejectWithValue, getState }) => {
        try {
            const state = getState() as RootState;

            const userId = state.userAuthentication.user?.id;
            const token = localStorage.getItem("token");
            const headers = new Headers();
            headers.append("Authorization", `Bearer ${token}`);
            headers.append("Content-Type", "application/json");
            const response = await fetch(`${api.baseURL}asistencia/get-reporte-excel-asistencia`, {
                method: 'POST',
                body: JSON.stringify({ "id": userId, "month": month, "year": year, "organization": organization }),
                headers: headers,
            });
            const data = await response.blob();
            const file = new Blob([data], { type: 'application/vnd.ms-excel' });
            const fileURL = URL.createObjectURL(file);
            return fileURL
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
